

<template>
  <div>
    <subscribe-area />
    <!-- Footer Area Start -->
    <footer class="footer_area">
      <div class="footer_top">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-12 col-lg-12 d-lg-none">
              <div class="footer_widget">
                <div class="logo_footer">
                  <img src="../assets/img/logo_black.png" alt="img" />
                </div>
                
                <div class="footer_socials">
                  <div class="content_socials">
                    <ul class="socials_list">
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-pinterest-p"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="footer_widget">
                <div class="footer_desc">
                  <p>
                    J. Gorostiza 1143, Zona Urbana Río Tijuana<br />
                    22010 Tijuana, B.C., México
                  </p>
                  <p>Teléfono: <span>+52 1 664 798 0740</span></p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 d-none d-lg-block">
              <div class="footer_widget">
                <div class="logo_footer">
                  <img src="../assets/img/logo_black.png" alt="img" />
                </div>

                <div class="footer_socials">
                  <div class="content_socials">
                    <ul class="socials_list">
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;">
                          <i class="fab fa-pinterest-p"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="footer_widget">
                <div class="footer_listitem">
                  <div class="listitem_inner">
                    <h4 class="footer_title">Horario</h4>
                    <ul class="open_hours">
                      <li><span>Mar - Sáb:</span> <span>3:00 pm – 10:00 pm</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="copyright">
                <p>
                  &copy; Copyright 2026 RM Pizzas. Todos los derechos reservados.
                  Desarrollado por
                  <a
                    href="https://bmostudios.com/es/inicio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    >BMO Studios</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer Area End -->
  </div>
</template>
<script>
import SubscribeArea from "../components/SubscribeArea";

export default {
  name: "Footer",
  //components: {SubscribeArea}
};
</script>



// WEBPACK FOOTER //
// src/layout/AppFooter.vue